const STORAGE_KEY = "bp_chart_balance_refresh";
const MESSAGE_TYPE = "chart-balance-refresh";

function getStoredTs() {
  return Number(localStorage.getItem(STORAGE_KEY)) || 0;
}

/** Call from the cash/credit popup after a successful deposit. */
export function notifyChartBalanceRefresh() {
  const ts = Date.now();
  localStorage.setItem(STORAGE_KEY, String(ts));

  try {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: MESSAGE_TYPE, ts },
        window.location.origin
      );
    }
  } catch (err) {
    console.error('[Balance Refresh] Error sending postMessage:', err);
  }
}

/**
 * Listen for balance updates from the popup window.
 * Uses localStorage polling because the storage event does not fire in the same tab.
 */
export function onChartBalanceRefresh(callback) {
  let lastTs = getStoredTs();

  const run = (ts, source) => {
    if (!ts || ts <= lastTs) return;
    lastTs = ts;
    callback();
  };

  const onStorage = (event) => {
    if (event.key !== STORAGE_KEY) return;
    run(Number(event.newValue) || 0, 'storage-event');
  };

  const onMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.data?.type !== MESSAGE_TYPE) return;
    run(Number(event.data.ts) || 0, 'postMessage');
  };

  const timer = setInterval(() => {
    const currentTs = getStoredTs();
    if (currentTs > lastTs) {
      run(currentTs, 'polling');
    }
  }, 1000);

  window.addEventListener("storage", onStorage);
  window.addEventListener("message", onMessage);

  return () => {
    window.removeEventListener("storage", onStorage);
    window.removeEventListener("message", onMessage);
    clearInterval(timer);
  };
}
